import PropTypes from 'prop-types'
import { Form } from 'antd'

const FormField = ({ children, ...props }) => (
  <Form.Item {...props}>{children}</Form.Item>
)

FormField.propTypes = {
  children: PropTypes.element.isRequired,
}

export default FormField
